import { Box, TextField, Typography } from "@mui/material";
import { useStyles } from "../styles";
import { useStepperData } from "../../../Helpers/Contexts/stepperContext";
import { REGEX } from "../../../Helpers/constant";

const Experience = () => {
  const classes = useStyles();
  const { formData, updateFormData } = useStepperData();

  const handleExperienceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (REGEX.NUMBERWITHDECIMAL2.test(value)) {
    updateFormData("Total_Years_of_Experience_In_Years__c", value);
    }
  };

  return (
    <>
      <Typography
        variant="h1"
        className={`${classes.headerTitle} label required`}
        mb={2}
      >
        How experienced are you?
      </Typography>
      <Typography className={classes.headerDescription} mb={4}>
        Let us know your total years of experience in your field (in years).
      </Typography>
      <TextField
        fullWidth
        placeholder="Years of experience (in years)"
        value={formData.Total_Years_of_Experience_In_Years__c || ""}
        onChange={handleExperienceChange}
      />
    </>
  );
};

export default Experience;
